exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-body[data-v-72fe5233]{height:calc(100vh - 80px);overflow:auto;padding-bottom:30px;padding:0 30 30 0}.el-tag[data-v-72fe5233]{margin-right:10px;margin-bottom:10px}", "", {"version":3,"sources":["/home/www/deploy/school/src/components/form_custom/preview/index.vue"],"names":[],"mappings":"AACA,4BACE,0BAA2B,AAC3B,cAAe,AACf,oBAAqB,AACrB,iBAAmB,CACpB,AACD,yBACE,kBAAmB,AACnB,kBAAoB,CACrB","file":"index.vue","sourcesContent":["\n.form-body[data-v-72fe5233] {\n  height: calc(100vh - 80px);\n  overflow: auto;\n  padding-bottom: 30px;\n  padding: 0 30 30 0;\n}\n.el-tag[data-v-72fe5233] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72fe5233","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form_custom/preview/index.vue
// module id = xres
// module chunks = 1 8 9 12 13 14